import { SUCCESS_RESPONSES, TEXT_ALERT_PREFERENCES_API } from 'constants/AppConstants';

const mockJson = {
  alerts: [
    {
      alertId: 1,
      active: true,
      overridesChildren: false,
    },
    {
      alertId: 2,
      active: true,
      overridesChildren: false,
    },
    {
      alertId: 4,
      active: true,
      overridesChildren: false,
    },
  ],
  mobileNumber: '9999999999',
  mobileProviderId: 2,
  receiveSMSAlerts: true,
};

export default async () => {
  try {
    const response = await fetch(TEXT_ALERT_PREFERENCES_API);
    const json = await response.json();
    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: true, json: mockJson };
    return { ok: true, json };
  } catch (err) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
